<script setup>
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import InputMask from "primevue/inputmask";

const emits = defineEmits([
    "next",
    "validate",
    "change-email",
    "download",
]);
const props = defineProps([
    "form",
    "errors",
    "isValidating",
    "isValidated",
    "validationError",
    "genderOptions",
    "v$",
    "isEdit"
]);

const changeEmail = () => {
    props.isValidated = false
}

</script>

<template>
    <div class="lato p-7 rounded my-2">
        <div class="mb-6 flex justify-between">
            <h1 class="text-xl font-semibold ">
                Bitte gib deine persönlichen Daten ein
            </h1>

            <i v-if="isEdit"
               class="pi pi-file-pdf text-[#C5C6CC] cursor-pointer"
               @click="emits('download')"></i>
        </div>


        <div class="my-4">
            <label class="p-1 text-[14.5px] font-bold">Email</label>
            <InputText
                v-model="form.email"
                :invalid="v$.form.email.$error"
                type="email"
                class="w-full"
                autocomplete="off"
                @input="v$.form.email.$touch"
                @blur="v$.form.email.$touch"
                :readonly="isValidated"
            />

            <div v-if="v$.form.email.$error" class="text-sm text-[#dc2626]">
                {{ v$.form.email.$errors[0].$message }}
            </div>

            <div v-if="! isEdit && isValidated" class="mt-1">
                <a href="#" @click.prevent="emits('change-email')">Ändern Sie</a>
            </div>
        </div>

        <template v-if="isValidated">
            <div class="grid grid-cols-2 gap-4 my-4">
                <div class="">
                    <label class="p-1 text-[14.5px] font-bold">Vorname</label>

                    <InputText
                        v-model="form.first_name"
                        :invalid="v$.form.first_name.$error"
                        type="text"
                        class="w-full"
                        @input="v$.form.first_name.$touch"
                        @blur="v$.form.first_name.$touch"
                    />

                    <div v-if="v$.form.first_name.$error" class="text-sm text-[#dc2626]">
                        {{ v$.form.first_name.$errors[0].$message }}
                    </div>
                </div>

                <div class="">
                    <label class="p-1 text-[14.5px] font-bold">Nachname</label>

                    <InputText
                        :invalid="v$.form.last_name.$error"
                        v-model="form.last_name"
                        type="text"
                        class="w-full"
                        @input="v$.form.last_name.$touch"
                        @blur="v$.form.last_name.$touch"
                    />

                    <div v-if="v$.form.last_name.$error" class="text-sm text-[#dc2626]">
                        {{ v$.form.last_name.$errors[0].$message }}
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-3 gap-4 my-4">
                <div class="col-span-2">
                    <label class="p-1 text-[14.5px] font-bold">Strasse</label>

                    <InputText
                        :invalid="v$.form.street.$error"
                        v-model="form.street"
                        type="text"
                        class="w-full"
                        @input="v$.form.street.$touch"
                        @blur="v$.form.street.$touch"
                    />

                    <div v-if="v$.form.street.$error" class="text-sm text-[#dc2626]">
                        {{ v$.form.street.$errors[0].$message }}
                    </div>
                </div>

                <div class="">
                    <label class="p-1 text-[14.5px] font-bold">Hausnummer</label>

                    <InputText
                        :invalid="v$.form.number.$error"
                        v-model="form.number"
                        type="text"
                        class="w-full"
                        @input="v$.form.number.$touch"
                        @blur="v$.form.number.$touch"
                    />

                    <div v-if="v$.form.number.$error" class="text-sm text-[#dc2626]">
                        {{ v$.form.number.$errors[0].$message }}
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-3 gap-4 my-4">
                <div class="">
                    <label class="p-1 text-[14.5px] font-bold">PLZ</label>

                    <InputText
                        :invalid="v$.form.zip_code.$error"
                        v-model="form.zip_code"
                        type="text"
                        class="w-full"
                        @input="v$.form.zip_code.$touch"
                        @blur="v$.form.zip_code.$touch"
                    />

                    <div v-if="v$.form.zip_code.$error" class="text-sm text-[#dc2626]">
                        {{ v$.form.zip_code.$errors[0].$message }}
                    </div>
                </div>

                <div class="col-span-2">
                    <label class="p-1 text-[14.5px] font-bold">Stadt</label>

                    <InputText
                        :invalid="v$.form.city.$error"
                        v-model="form.city"
                        type="text"
                        class="w-full"
                        @input="v$.form.city.$touch"
                        @blur="v$.form.city.$touch"
                    />

                    <div v-if="v$.form.city.$error" class="text-sm text-[#dc2626]">
                        {{ v$.form.city.$errors[0].$message }}
                    </div>
                </div>
            </div>

            <div class="my-4">
                <label class="p-1 text-[14.5px] font-bold">Telefon</label>

                <InputMask
                    :invalid="v$.form.phone.$error"
                    v-model="form.phone"
                    mask="9999999999"
                    @input="v$.form.phone.$touch"
                    @blur="v$.form.phone.$touch"
                    class="block w-full" />

                <div v-if="v$.form.phone.$error" class="text-sm text-[#dc2626]">
                    {{ v$.form.phone.$errors[0].$message }}
                </div>
            </div>

            <div class="my-4">
                <label class="p-1 text-[14.5px] font-bold">Natel</label>

                <InputText
                    :invalid="v$.form.mobile_phone.$error"
                    v-model="form.mobile_phone"
                    class="w-full"
                    @input="v$.form.mobile_phone.$touch"
                    @blur="v$.form.mobile_phone.$touch"
                />

                <div v-if="v$.form.mobile_phone.$error" class="text-sm text-[#dc2626]">
                    {{ v$.form.mobile_phone.$errors[0].$message }}
                </div>
            </div>

            <div class="my-4">
                <label class="p-1 text-[14.5px] font-bold">Beruf</label>

                <InputText
                    :invalid="v$.form.profession.$error"
                    v-model="form.profession"
                    class="w-full"
                    @input="v$.form.profession.$touch"
                    @blur="v$.form.profession.$touch"
                />

                <div v-if="v$.form.profession.$error" class="text-sm text-[#dc2626]">
                    {{ v$.form.profession.$errors[0].$message }}
                </div>
            </div>

            <div class="grid grid-cols-2 gap-4 my-4">
                <div class="">
                    <label class="p-1 text-[14.5px] font-bold">Geschlecht</label>

                    <Dropdown
                        :invalid="v$.form.gender.$error"
                        v-model="form.gender"
                        :options="genderOptions"
                        optionLabel="label"
                        optionValue="value"
                        class="w-full md:w-14rem"
                        @input="v$.form.gender.$touch"
                        @blur="v$.form.gender.$touch"
                    />

                    <div v-if="v$.form.gender.$error" class="text-sm text-[#dc2626]">
                        {{ v$.form.gender.$errors[0].$message }}
                    </div>
                </div>

                <div class="">
                    <label class="p-1 text-[14.5px] font-bold">Geburtstag</label>

                    <InputMask
                        :invalid="v$.form.birthdate.$error"
                        v-model="form.birthdate"
                        mask="99.99.9999"
                        placeholder="tt.mm.jjjj"
                        @input="v$.form.birthdate.$touch"
                        @blur="v$.form.birthdate.$touch"
                        class="block w-full" />

                    <div v-if="v$.form.birthdate.$error" class="text-sm text-[#dc2626]">
                        {{ v$.form.birthdate.$errors[0].$message }}
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-2 gap-4 my-4">
                <div class="">
                    <label class="p-1 text-[14.5px] font-bold">Gewicht</label>

                    <InputGroup class="w-full">
                        <InputText
                            :invalid="v$.form.weight.$error"
                            v-model="form.weight"
                            type="number"
                            step=".01"
                            @input="v$.form.weight.$touch"
                            @blur="v$.form.weight.$touch"
                        />

                        <InputGroupAddon>kg</InputGroupAddon>
                    </InputGroup>

                    <div v-if="v$.form.weight.$error" class="text-sm text-[#dc2626]">
                        {{ v$.form.weight.$errors[0].$message }}
                    </div>
                </div>

                <div class="">
                    <label class="p-1 text-[14.5px] font-bold">Grösse</label>
                    <InputGroup class="w-full">
                        <InputText
                            :invalid="v$.form.height.$error"
                            v-model="form.height"
                            type="number"
                            step=".01"
                            @input="v$.form.height.$touch"
                            @blur="v$.form.height.$touch"
                        />

                        <InputGroupAddon>cm</InputGroupAddon>
                    </InputGroup>

                    <div v-if="v$.form.height.$error" class="text-sm text-[#dc2626]">
                        {{ v$.form.height.$errors[0].$message }}
                    </div>
                </div>
            </div>
        </template>

        <div class="flex mt-10 justify-end">
            <Button v-if="isValidated"
                label="weiter"
                class="min-w-[100px] bg-black text-[#FFF053] border-none"
                @click="emits('next', 'program', 'profile')"
            />
            <Button v-else
                label="weiter"
                class="min-w-[100px] bg-black text-[#FFF053] border-none"
                :loading="isValidating"
                @click="emits('validate')"
            />
        </div>
    </div>
</template>
